import { render, staticRenderFns } from "./SubmitResult.vue?vue&type=template&id=73cc15b2&scoped=true"
import script from "./SubmitResult.vue?vue&type=script&lang=js"
export * from "./SubmitResult.vue?vue&type=script&lang=js"
import style0 from "./SubmitResult.vue?vue&type=style&index=0&id=73cc15b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc15b2",
  null
  
)

export default component.exports